import { useState } from 'react';
import { useAdminStore } from '../../stores/adminStore';
import './AdminPanel.css';

interface AdminPanelProps {
  onClose: () => void;
}

export function AdminPanel({ onClose }: AdminPanelProps) {
  const { gcpApiKey, setGcpApiKey, logs, clearLogs } = useAdminStore();
  const [apiKeyInput, setApiKeyInput] = useState(gcpApiKey);
  const [activeTab, setActiveTab] = useState<'logs' | 'settings'>('logs');

  const handleSaveSettings = (e: React.FormEvent) => {
    e.preventDefault();
    setGcpApiKey(apiKeyInput);
    alert('Settings saved!');
  };

  return (
    <div className="admin-panel-overlay">
      <div className="admin-panel">
        <div className="admin-header">
          <h2>Admin Settings</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="admin-tabs">
          <button 
            className={`tab-btn ${activeTab === 'logs' ? 'active' : ''}`}
            onClick={() => setActiveTab('logs')}
          >
            Audit Logs
          </button>
          <button 
            className={`tab-btn ${activeTab === 'settings' ? 'active' : ''}`}
            onClick={() => setActiveTab('settings')}
          >
            Cloud OCR Settings
          </button>
        </div>

        <div className="admin-content">
          {activeTab === 'logs' && (
            <div className="logs-section">
              <div className="logs-header-action">
                <p>Recent activity across the application.</p>
                <button onClick={clearLogs} className="btn-secondary btn-small">Clear Logs</button>
              </div>
              
              <div className="table-container">
                <table className="logs-table">
                  <thead>
                    <tr>
                      <th>Time</th>
                      <th>Role</th>
                      <th>Action</th>
                      <th>IP Address</th>
                      <th>Device</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.length === 0 ? (
                      <tr>
                        <td colSpan={6} style={{ textAlign: 'center', padding: '2rem' }}>No logs available.</td>
                      </tr>
                    ) : (
                      logs.map((log) => (
                        <tr key={log.id}>
                          <td>{new Date(log.timestamp).toLocaleString()}</td>
                          <td><span className={`role-badge ${log.userRole}`}>{log.userRole}</span></td>
                          <td><strong>{log.action}</strong></td>
                          <td>{log.ipAddress}</td>
                          <td title={log.deviceInfo}>{log.deviceInfo.substring(0, 30)}...</td>
                          <td>{JSON.stringify(log.details)}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'settings' && (
            <div className="settings-section">
              <div className="settings-card">
                <h3>Google Cloud Vision OCR</h3>
                <p>Enter your Google Cloud API Key to enable text extraction for all users.</p>
                <form onSubmit={handleSaveSettings}>
                  <div className="form-group">
                    <label htmlFor="apiKey">API Key</label>
                    <input 
                      id="apiKey"
                      type="password" 
                      value={apiKeyInput}
                      onChange={(e) => setApiKeyInput(e.target.value)}
                      placeholder="AIzaSy..."
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">Save Settings</button>
                </form>
                <div className="help-text">
                  <p><strong>Note:</strong> In this development mode, the key is saved in your local storage. Once Supabase is connected, the key should be moved to the Edge Function secrets.</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
